export const MODAL_LIST_ITEMS = [
  'в выписке из ЕГРН;',
  'в техпаспорте или межевом плане;',
  'в документах о праве собственности;',
];
